export default "__VITE_ASSET__Pxi6tggK__"